import {
  ActionReducerMapBuilder,
  EntityState,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { classToPlain } from 'class-transformer';

import { AppError } from '@vk-hr-tek/core/error';

import { ThunkExtra } from '@app/store';
import { WidgetTasksResponse, DashboardService } from '@app/gen/dashboard';
import { DynamicEntity } from '@app/types';

import { DashboardState } from '../dashboard.state';

export const getTaskList = createAsyncThunk<
  WidgetTasksResponse['tasks'],
  undefined,
  ThunkExtra
>(
  'dashboard/getTaskList',
  async (_, { rejectWithValue, extra: { inject } }) => {
    try {
      const result = await inject(DashboardService).getWidgetTasks();

      return result.tasks;
    } catch (err) {
      return rejectWithValue(classToPlain(err) as AppError);
    }
  },
);

export const taskListReducers = (
  builder: ActionReducerMapBuilder<
    EntityState<DynamicEntity, string> & DashboardState
  >,
) => {
  builder.addCase(getTaskList.pending, (state) => {
    state.taskList.status = 'loading';
  });
  builder.addCase(getTaskList.fulfilled, (state, { payload }) => {
    state.taskList.status = 'complete';
    state.taskList.items = payload;
  });
  builder.addCase(getTaskList.rejected, (state) => {
    state.taskList.status = 'failed';
  });
};
